namespace Nobox.Nobox {
    export interface LeadForm {
        Name: Serenity.StringEditor;
        Category: Serenity.StringEditor;
        ListId: Serenity.ServiceLookupEditor;
        Tags: Serenity.ServiceLookupEditor;
        Manager: Serenity.StringEditor;
        Notes: Serenity.StringEditor;
        linkGrid: Serenity.Extensions.StaticTextBlock;
        Address: Serenity.StringEditor;
        Country: Serenity.ServiceLookupEditor;
        State: StateNmLookupEditor;
        City: CityNmLookupEditor;
        Postal: Serenity.StringEditor;
        LocatedIn: Serenity.StringEditor;
        Latitude: Serenity.StringEditor;
        Longitude: Serenity.StringEditor;
        Location: Serenity.StringEditor;
        IsBlock: Serenity.BooleanEditor;
        Custom: Serenity.Extensions.StaticTextBlock;
        Tool: Serenity.ServiceLookupEditor;
        Search: Serenity.StringEditor;
        Url: Serenity.StringEditor;
        Website: Serenity.StringEditor;
        VatNumber: Serenity.StringEditor;
        Rating: Serenity.StringEditor;
        Reviews: Serenity.StringEditor;
        Photo: ContactFileEditor;
        ExtSites: Serenity.StringEditor;
        OpenHours: Serenity.StringEditor;
        In: CustomDateTimeEditor;
        Up: CustomDateTimeEditor;
        LinkId: Serenity.StringEditor;
    }

    export class LeadForm extends Serenity.PrefixedContext {
        static formKey = 'Nobox.Lead';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LeadForm.init)  {
                LeadForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.ServiceLookupEditor;
                var w2 = s.Extensions.StaticTextBlock;
                var w3 = StateNmLookupEditor;
                var w4 = CityNmLookupEditor;
                var w5 = s.BooleanEditor;
                var w6 = ContactFileEditor;
                var w7 = CustomDateTimeEditor;

                Q.initFormType(LeadForm, [
                    'Name', w0,
                    'Category', w0,
                    'ListId', w1,
                    'Tags', w1,
                    'Manager', w0,
                    'Notes', w0,
                    'linkGrid', w2,
                    'Address', w0,
                    'Country', w1,
                    'State', w3,
                    'City', w4,
                    'Postal', w0,
                    'LocatedIn', w0,
                    'Latitude', w0,
                    'Longitude', w0,
                    'Location', w0,
                    'IsBlock', w5,
                    'Custom', w2,
                    'Tool', w1,
                    'Search', w0,
                    'Url', w0,
                    'Website', w0,
                    'VatNumber', w0,
                    'Rating', w0,
                    'Reviews', w0,
                    'Photo', w6,
                    'ExtSites', w0,
                    'OpenHours', w0,
                    'In', w7,
                    'Up', w7,
                    'LinkId', w0
                ]);
            }
        }
    }
}
